import {map} from "lodash";

function countryTemplate() {
	return (country) => `
	
		<div>
			<span class="flag-icon ${country.code.toLowerCase()}"></span>
			<span>${country.name_pl}</span>
		</div>
	
	`;
}

function countriesTemplate($filter) {
	"ngInject";
	return (countries) => {
		map(countries, country => $filter("countryTemplate")(country).trim()).join("");
		return map(countries, country => $filter("countryTemplate")(country).trim()).join("");
	};
}

export {countryTemplate, countriesTemplate};


// WEBPACK FOOTER //
// ./sources/filters/countries.js